import { LucideProps } from "lucide-react";

export function DragonIcon(props: LucideProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            {...props}
        >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            {/* Dragon Head Silhouette */}
            <path d="M19 12c-.667 -1.333 -1.333 -2.667 -2 -4c-2 -3 -5 -3 -8 -1c-1.333 1.333 -2.667 2.667 -4 4c1 1 2 2 3 3c2 2 5 2 8 0c1 -0.667 2 -1.333 3 -2" />
            <path d="M11 14c0 1 -1 2 -2 2s-2 -1 -2 -2" />
            <path d="M15 12l4 -5l-2.5 -2.5c-2.5 -2.5 -6.5 -2.5 -9 0l-1.5 1.5" />
        </svg>
    );
}
